"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { REFERRAL_DASHBOARD_KEY } from "@/hooks/use-referral-dashboard"
import { REFERRAL_CLICKS_KEY } from "@/hooks/use-referral-clicks"

interface CreateLinkParams {
  type: string
  code?: string
  note?: string
  metadata?: Record<string, unknown>
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
}

interface CreateLinkResponse {
  code: string
  link: string
  type: string
}

export const useCreateLink = () => {
  const queryClient = useQueryClient()

  return useMutation<CreateLinkResponse, Error, CreateLinkParams>({
    mutationFn: async ({ type, code, note, metadata, utm_source, utm_medium, utm_campaign, utm_content }) => {
      const res = await fetch("/api/referral/create-link", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type, code, note, metadata, utm_source, utm_medium, utm_campaign, utm_content }),
      })
      if (!res.ok) {
        const body = await res.json().catch(() => ({}))
        throw new Error(body.error ?? "Failed to create link")
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: REFERRAL_DASHBOARD_KEY })
      queryClient.invalidateQueries({ queryKey: REFERRAL_CLICKS_KEY })
    },
  })
}
